// src/pages/CourseTime/styles/slides.styles.js
import styled, {createGlobalStyle, keyframes} from 'styled-components';
import spinnerImage from '../../../assets/images/dq-spinner.png';

// Simple grey flashing skeleton animation
const skeletonPulse = keyframes`
  0% { opacity: 0.5; }
  50% { opacity: 1; }
  100% { opacity: 0.5; }
`;

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 77vh; /* full height */
`;

// Slide viewer and navigation
export const SlideViewer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
`;

export const SessionContent = styled.div`
  flex: 1;
  padding: 0 40px;
  width: 90%;
  max-width: 92vw;
  height: 100%;
  overflow-y: auto;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 3px;
  }
    @media (max-width: 1024px) {
        display: flex;
        overflow: unset;
    }
    @media (max-width: 768px) {
        padding: 0;
        width: auto;
    }
    @media (min-width: 830px) and (max-width: 1024px) {
        padding: 0;
        overflow: unset;
        align-items: center;
        justify-content: center;
    }
`;


export const SlideNavNext = styled.div`
  top: 50%;
  position: fixed;
  width: 7vh;
  height: 14vh;
  right: 0;
  border-top-left-radius: 9vh;
  border-bottom-left-radius: 9vh;
  display: flex;
  align-items: center;
  cursor: pointer;
  z-index: 99;
  background-color: ${({ bg }) => bg || '#32BAF1'};
    
    @media (max-width: 1024px) {
        width: 4vh;
        height: 8vh;
    }

    @media (max-width: 768px) {
        z-index: 1;
    }
`;

export const SlideNavPrev = styled.div`
  top: 50%;
  left: ${({ collapsed }) => (collapsed ? '60px' : '380px')};
  transition: all 0.3s ease;
  z-index: 99;
  background-color: ${({ bg }) => bg || '#32BAF1'};
  border-top-right-radius: 9vh;
  border-bottom-right-radius: 9vh;
  cursor: pointer;
  position: fixed;
  width: 7vh;
  height: 14vh;
  display: flex;
  align-items: center;

  &:hover {
    opacity: 0.9;
  }

  @media (max-width: 1024px) {
      left: ${({ collapsed }) => (collapsed ? '0' : '300px')};
      width: 4vh;
      height: 8vh;
  }
    
    @media (max-width: 768px) {
      z-index: 1;
  }
`;

export const SlideNavPrevImg = styled.img`
  height: 6vh;
  position: absolute;
  left: 18%;

    @media (max-width: 1024px) {
        height: 4vh;
        left: 13%;
    }
`;

export const SlideNavNextImg = styled.img`
  right: 16%;
  height: 6vh;
  position: absolute;
    @media (max-width: 1024px) {
        height: 4vh;
        left: 55%;
    }
`;

// Slide content styling
export const Slide = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 68vh;
  padding: 30px 40px;
  justify-content: flex-start;

    @media (max-width: 830px) {
        padding: 0 !important;
        width: 100%;
        min-height: 50vh;
    }
    
    @media (max-width: 768px) {
        min-height: 50vh;
    }

    @media only screen and (min-width: 830px) and (max-width: 1024px) {
        min-height: 50vh;
        padding: 0;
    }
`;

export const TTSHighlightStyles = createGlobalStyle`
    /* TTS word highlighting */
    .tts-word { transition: background-color .12s ease; }
    .tts-word--active { background-color: rgba(255, 235, 59, .6); border-radius: 4px; }
`;

export const TTSControls = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 32px auto;
    gap: 12px;
    padding: 8px 5px;
    border-radius: 20px;
    background: ${({ bg }) => bg || '#ED6628'};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    backdrop-filter: blur(6px);
    height: 43px;
    width: 170px;

    button {
        width: 52px;
        height: 52px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.2s ease;
    }
`;

// Dedicated TTS pause/play button with cross-browser gradient support
export const TTSPauseButton = styled.button`
    background-color: #fff;
    color: ${({ themeColor }) => themeColor || '#ED7239'};
    width: 60px;
    height: 60px;
    border: none;
    border-radius: 50%;
    /* Multiple vendor-prefixed gradients for wider browser support */
    background-image: -webkit-linear-gradient(top, #f7f7f7, #e7e7e7);
    background-image: -moz-linear-gradient(top, #f7f7f7, #e7e7e7);
    background-image: -ms-linear-gradient(top, #f7f7f7, #e7e7e7);
    background-image: -o-linear-gradient(top, #f7f7f7, #e7e7e7);
    background-image: -webkit-gradient(linear, left top, left bottom, from(#f7f7f7), to(#e7e7e7));
    box-shadow: 0px 2px 6px #aaa, inset 0px 2px 3px #fff;
    position: absolute;
    top: -4px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 20;
    transition: all 0.25s ease;
    outline: none;
    display: flex;
    align-items: center;
    justify-content: center;
`;


// --- Styled wrappers ---

export const PopoverWrapper = styled.div`
    position: absolute;
    bottom: calc(100% + 0px);
    left: 80%;
    background: linear-gradient(
            135deg,
            rgba(250, 250, 255, 0.95) 0%,   /* soft light top-left */
            rgba(245, 245, 250, 0.9) 50%,   /* gentle neutral middle */
            rgba(240, 240, 255, 0.92) 100%  /* faint bluish base */
    );
    backdrop-filter: blur(16px) saturate(180%);
    -webkit-backdrop-filter: blur(16px) saturate(180%);
    border: 1px solid rgba(255, 255, 255, 0.6);
    border-radius: 20px;
    padding: 20px 16px;
    box-shadow:
            0 8px 30px rgba(0, 0, 0, 0.15),
            0 4px 12px rgba(0, 0, 0, 0.1),
            inset 0 1px 0 rgba(255, 255, 255, 0.6);
    z-index: 2000;
    min-width: 280px;
    animation: fadeIn 0.25s ease;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background: radial-gradient(
                circle at top right,
                rgba(255, 255, 255, 0.25) 0%,
                rgba(255, 255, 255, 0) 70%
        );
        border-radius: 20px;
        z-index: -1;
        pointer-events: none;
    }

    @keyframes fadeIn {
        from { opacity: 0; transform: translateY(12px); }
        to { opacity: 1; transform: translateY(0); }
    }
`;

export const PopoverHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  margin-top: -20px;
`;

export const Title = styled.h3`
  font-weight: 600;
  font-size: 20px;
  color: ${({ themeColor }) => themeColor || '#EE6D29'};
    margin: 0 auto;
    text-align: center;
`;

export const Label = styled.label`
  font-size: 13px;
    text-align: left;
    font-weight: 500;
    display: block;
    margin-bottom: 6px;
    color: #374151;
`;

export const SelectBox = styled.select`
    width: 100%;
    padding: 8px 10px;
    border-radius: 10px;
    border: 1px solid #d1d5db;
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(8px);
    font-size: 14px;
    margin-bottom: 16px;
    transition: border-color 0.2s ease;

    &:focus {
        border-color: ${({ themeColor }) => themeColor || '#EE6D29'};
        outline: none;
    }
`;

export const RangeLabel = styled.div`
    font-size: 12px;
    color: #6b7280;
    margin: 8px 0 4px;
`;

export const Slider = styled.input.attrs({ type: "range" })`
    width: 100%;
    margin-bottom: 16px;
    appearance: none;
    height: 4px;
    border-radius: 4px;
    background: ${({ themeColor }) => themeColor || '#ee6d29'};
    outline: none;
    cursor: pointer;

    &::-webkit-slider-thumb {
        appearance: none;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: #fff;
        border: 2px solid ${({ themeColor }) => themeColor || '#ee6d29'};
        box-shadow: 0 0 2px rgba(0,0,0,0.3);
        transition: transform 0.15s ease;
    }

    &::-webkit-slider-thumb:hover {
        transform: scale(1.1);
    }
`;

// Activity Pill with Pointed Corner
export const ActivityPill = styled.div`
  width: 55%;
  position: relative;
  display: block;
  background: #000000;
  color: white;
  padding: 12px 16px 12px 0;
  font-size: 18px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-radius: 0 20px 0 0;
  margin-bottom: 12px;
  margin-left: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

    @media (max-width: 768px) {
    padding: 6px 12px 6px 10px;
    font-size: 11px;
    
    &::after {
      bottom: -6px;
      border-width: 6px 6px 0 0;
    }
  }
`;

export const FullActivityPill = styled(ActivityPill)`
  width: 100%;
  text-align: center;
  
  @media (max-width: 1024px) {
    width: 55%;
  }
`;

export const SlideTitle = styled.h2`
  text-align: left;
  margin-bottom: 30px;
  font-size: 42px;
  color: #EE6D29;
  font-weight: 700;
  position: relative;
  padding-bottom: 15px;
    &:empty {
        display: none;
        margin-bottom: 0;
        padding-bottom: 0;
    }
    
    @media only screen and (min-width: 768px) and (max-width: 1024px) {
        font-size: 33px;
        line-height: 1.2;
    }
    @media (max-width: 768px) {
        font-size: 25px;
    }
`;

export const SlideTitleMobile = styled(SlideTitle)`
 display: none;
    
    @media (max-width: 830px) {
       display: block;
        padding-bottom: 0;
        margin-bottom: 0;
    }
`;

export const SlidePoints = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 800px;
  margin: 0 auto;
`;

export const SlidePoint = styled.div`
  border-radius: 8px;
  transition: transform 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
  }
`;

export const SinglePoint = styled(SlidePoint)`
  max-width: 100%;
  font-size: 1.1em;
`;

export const PointTitle = styled.h3`
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 18px;
  color: #000;
  font-weight: 600;
`;

export const PointText = styled.p`
  margin: 0;
  color: #000;
  line-height: 1.6;
  font-size: 22px;
    @media (max-width: 1024px) {
    font-size: 18px;
}
`;

export const SlideDescription = styled.div`
  line-height: 1.7;
  color: #000;
  font-size: 18px;
  max-width: 90%;
  margin-right: 30px;
  margin-left: 30px;
  border-radius: 8px;
  @media (max-width: 768px) {
    margin-left: 23px;
    margin-right: 23px;
  }
`;

export const SlideImages = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 24px;
  justify-content: center;
`;

export const SlideImage = styled.img`
  max-width: 100%;
  max-height: 460px;
  object-fit: contain;
  border-radius: 8px;
  transition: transform 0.2s ease;
  
  &:hover {
    transform: scale(1.02);
  }
    @media (max-width: 768px) {
        max-width: 82%;
    }
    
    @media (max-width: 830px) {
        max-width: 90%;
    }
    
    @media (min-width:830px) and (max-width: 1024px) {
        max-width: 45%;
        max-height: none;
    }
`;

// Two-column layout with image on left
export const SlideWithImage = styled.div`
  display: flex;
  gap: 30px;
  align-items: center;
  width: 100%;
  min-height: 60vh;
  margin-left: 30px;
  margin-right: 30px;

 @media (max-width: 768px) {
   margin-left: 23px;
   margin-right: 20px;
   flex-direction: column !important;  
   width: auto;
   align-items: center;
   justify-content: center;
 }
    @media (max-width: 786px) {
        margin-left: 30px;
        margin-right: 30px;
        align-items: center;
    }  
    
    @media (min-width: 786px) and (max-width: 830px) {
        margin-left: 0;
        margin-right: 0;
        align-items: center;
   }  
    
  @media (max-width: 1024px) {
    flex-direction: column;
      min-height: 35vh;
      align-items: center;
  }
`;

export const SlideImageContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 40px;
    @media (max-width: 768px) {
        padding-top: 0;
    }
`;

export const SlidePointsContainer = styled.div`
  flex: 1;
  margin-right: 30px;
  margin-top: auto;
  margin-bottom: auto;
    @media (max-width: 768px) {
        margin-right: 0;
    }
`;

export const SlideTitleContainer = styled.div`
  flex: 1;
  margin-right: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
    @media (max-width: 768px) {
        margin-right: 0;
    }

`;

export const SlideTopImageContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
    @media (max-width: 768px) {
        justify-content: center;
        align-items: center;
    }
    @media (max-width: 1024px) {
        justify-content: center;
        align-items: center;
    }
`;

// Single point with larger image
export const SlideSinglePointWithImage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
`;

export const SlideLargeImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
`;

export const SlideLargeImage = styled.img`
  max-width: 90%;
  max-height: 400px;
  object-fit: contain;
  border-radius: 8px;
`;

export const SlideList = styled.div`
  border-radius: 8px;
  margin-right: 30px;
  margin-left: 30px;
  
  ul {
    padding-left: 20px;
  }

  li {
    margin-bottom: 12px;
    font-size: clamp(16px, 2vw, 21px);
    color: #000;
    line-height: 1.6;
    list-style-type: disc;
  }

    @media (min-width:768px) and (max-width: 830px) {
        margin-right: 0;
        margin-left: 0;
    }
`;

// Container for all columns
export const StepBlockContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 24px;
  margin-top: 24px;
    @media (max-width: 830px) {
       width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        flex-wrap: nowrap;
        justify-content: flex-start;
        scroll-snap-type: x mandatory;
    }
    
    @media (max-width: 786px) {
      margin-left: 30px;
      margin-right: 30px;
      flex-wrap: nowrap;
    }

`;

// Flexible wrapper for HTML-based step content (e.g., <dl><dt>...</dt><dd>...</dd></dl>)
export const StepBlockHtmlWrapper = styled.div`
  margin-top: 24px;
  margin-left: 30px;
  margin-right: 30px;

  @media (max-width: 768px) {
    margin-left: 23px;
    margin-right: 23px;
  }

  dl {
    margin: 0;
  }

  dt {
    margin-top: 18px;
    font-weight: 600;
    font-size: 22px;
    color: #ee6d29;
  }

  dd {
    margin: 6px 0 0 0;
    font-size: 18px;
    line-height: 1.6;
    color: #000;
  }
`;

// Each individual column
export const TitleBox = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
`;

export const StepColumn = styled.div`
  flex: 0 1 ${props => {
    const count = Number(props.stepcount) || 4;
    if (count === 1) return '45%';
    if (count === 2) return '45%';
    if (count === 3) return '32%';
    return '24%';
  }};
  max-width: ${props => {
    const count = Number(props.stepcount) || 4;
    if (count === 1) return '235px';
    if (count === 2) return '370px';
    if (count === 3) return '320px';
    return '320px';
  }};
  min-width: 240px;
  min-height: 500px;
  border-radius: 10px;
  padding: 16px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
`;

export const StepTitle = styled.h3`
  text-align: center;
  font-weight: 600;
  margin-bottom: 12px;
  line-height: 1.2;
  color: #EE6D29;
  font-size: ${(props) => (props.iscondensed ? '25px' : '30px')};

    @media (max-width: 1024px) {
        min-height: 75px;
        font-size: 23px;
        text-align: left;
    }
    
    @media (max-width: 768px) {
        min-height: 75px;
        font-size: 23px;
        text-align: left;
    }
`;

export const StepText = styled.p`
  text-align: left;
  line-height: 1.5;
  color: #000;
  font-size: ${(props) => (props.iscondensed ? '19px' : '23px')};
    @media (max-width: 1024px) {
        font-size: 19px;
    }
`;

export const VideoLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 40px;
`;

export const VideoContainer = styled.div`
    width: 85%;
    max-width: 1300px;
    min-width: 700px;
    aspect-ratio: 16 / 9;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background-color: #000;

  @media (max-width: 768px) {
    max-width: 100%;
    min-width: 0;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    min-width: 600px;
  }
`;

export const VideoPlayer = styled.video`
    width: 100%;
    height: 100%;
    min-height: 100%;
    display: block;
    object-fit: contain;
`;

export const PledgeLayout = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
`;

export const LeftContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const RightBox = styled.div`
  flex: 1;
  margin: 20px;
  margin-top: 60px;
  background-color: #0097b2;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const IconWrapper = styled.img`
  max-width: 100%;
  max-height: 150px;
  object-fit: contain;
  border-radius: 8px;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.02);
  }
`;

export const PledgeDescription = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  margin-bottom: 24px;
`;

// Assessment Intro Template Styles
// Layout: Image LEFT of Title (same row)
export const AssessmentIntroContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  min-height: 60vh;
  margin-left: 30px;
  margin-right: 30px;
  justify-content: center;

  @media (max-width: 768px) {
    margin-left: 23px;
    margin-right: 20px;
    width: auto;
    min-height: 50vh;
  }
  
  @media (max-width: 1024px) {
    min-height: 50vh;
  }
`;

export const AssessmentIntroTopRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 30px;
  width: 100%;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
`;

export const AssessmentIntroImageContainer = styled.div`
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  
  @media (max-width: 768px) {
    padding-top: 0;
  }
`;

export const AssessmentIntroImage = styled.img`
  max-width: 250px;
  max-height: 250px;
  width: 250px;
  height: 250px;
  object-fit: contain;
  border-radius: 12px;
  transition: transform 0.2s ease;
  
  &:hover {
    transform: scale(1.02);
  }
  
  @media (max-width: 768px) {
    max-width: 200px;
    max-height: 200px;
    width: 200px;
    height: 200px;
  }
  
  @media (min-width: 768px) and (max-width: 1024px) {
    max-width: 220px;
    max-height: 220px;
    width: 220px;
    height: 220px;
  }
`;

export const AssessmentIntroContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  
  @media (max-width: 768px) {
    align-items: center;
    text-align: center;
  }
`;

export const AssessmentIntroTitle = styled.h1`
  font-size: 48px;
  font-weight: 700;
  color: #ED6628;;
  margin: 0;
  line-height: 1.3;
  text-align: left;
  
  @media (max-width: 1024px) {
    font-size: 38px;
  }
  
  @media (max-width: 768px) {
    font-size: 28px;
    text-align: center;
  }
`;

// Assessment Result Template Styles
export const QuizResultContainer = styled.div`
  padding: 0;
  width: 100%;
  text-align: center;
`;

export const ResultContent = styled.div`
  text-align: center;
`;

// Generic skeleton used for score and rubric loading states
export const ScoreSkeletonCircle = styled.div`
  width: clamp(160px, 22vw, 220px);
  height: clamp(160px, 22vw, 220px);
  border-radius: 50%;
  background: #e0e3ea;
  margin: 0 auto 16px;
  animation: ${skeletonPulse} 1.2s ease-in-out infinite;
`;

export const ScoreSkeletonLine = styled.div`
  width: ${({ width }) => width || '70%'};
  height: ${({ height }) => height || '14px'};
  border-radius: 999px;
  background: #e0e3ea;
  margin: 8px auto 0;
  animation: ${skeletonPulse} 1.2s ease-in-out infinite;
`;

export const RubricSkeletonRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 10px;
  margin-bottom: 8px;
`;

// Mimics the level column (`RubricLevelCell`)
export const RubricSkeletonBadge = styled.div`
  width: 50px;
  min-width: 50px;
  height: 56px;
  border-radius: 6px;
  background: #e0e3ea;
  flex-shrink: 0;
  animation: ${skeletonPulse} 1.2s ease-in-out infinite;
`;

// Mimics the right-hand description column (`RubricDescCell`)
export const RubricSkeletonContent = styled.div`
  flex: 1;
  border-left: 12px solid #e0e3ea;
  padding: 6px 10px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
`;

export const ResultBody = styled.div`
  font-weight: 400;
`;

export const ScoreContainer = styled.div`
  display: flex;
  justify-content: space-around;
  margin-left: auto;
  margin-right: auto;
  margin-top: 4vh;
  width: 100%;

  /* Side by side: the rubric table drops below the score ring when the row cannot
     give it its 420px basis (narrow window, or the sidebar open). */
  @media (min-width: 1025px) {
    flex-wrap: wrap;
    row-gap: 24px;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 0;
    width: 100%;
    gap: 2vh;
  }
  
  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
`;

export const ScoreContent = styled.div`
  padding: 0 6vh;
  
  @media (max-width: 768px) {
    width: 100%;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const ScoreSpinner = styled.div`
  background: url(${spinnerImage}) no-repeat center center;
  background-size: contain;
  padding: 10%;
  width: 25vw;
  height: 25vw;
  max-width: 250px;
  max-height: 250px;
  font-family: "Source Sans Pro", "Helvetica Neue", sans-serif;
  
  /* Responsive font size - scales with container */
  font-size: clamp(1.8em, 6vw, 3.2em);
  
  @media (max-width: 1024px) {
    width: 30vw;
    height: 30vw;
    font-size: clamp(1.6em, 5.5vw, 2.8em);
  }
  
  @media (max-width: 768px) {
    width: 35vw;
    height: 35vw;
    font-size: clamp(1.4em, 5vw, 2.2em);
  }
  
  @media (max-width: 480px) {
    width: 45vw;
    height: 45vw;
    font-size: clamp(1.2em, 4vw, 1.8em);
  }
  
  /* Ensure the spinner maintains aspect ratio */
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const ScoreDesc = styled.div`
  font-size: 1.3em;
  font-weight: bold;
  padding: 0.5em 1em;

  @media (max-width: 768px) {
    font-size: 1.1em;
    margin-bottom: 1vh;
  }
`;

export const RubricContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  background-color: #f4f2f3;
  border-radius: 15px;
  padding: 30px 18px;
  overflow-y: auto;
  scroll-snap-type: y;

  /* The descriptions are full sentences. Beside the score ring the table takes the
     room that is left, up to 640px (see the wrap rule on ScoreContainer). */
  @media (min-width: 1025px) {
    flex: 1 1 420px;
    max-width: 640px;
  }

  /* Stacked under the score ring: as wide as the slide allows */
  @media (max-width: 768px) {
    padding: 20px 16px;
    width: 100%;
    max-width: 95vw;
    margin: 2vh auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
    
    @media (min-width: 768px) and (max-width: 1024px) {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 640px;
    padding: 30px 18px;    
  }
`;

export const RubricContent = styled.div`
  text-align: left;
  width: 100%;
  font-size: 1rem;

  @media (max-width: 768px) {
    font-size: 0.85rem;
  }
`;

// Rubric table (Level | Description). Rows are boxes, not <tr>, so the learner's row
// can carry a rounded, shadowed background; AssessmentResultSlide sets the ARIA table
// roles. Same palette as the quiz result page rubric. The score scale runs down the
// left of the rows (RubricScaleTick).
const RUBRIC_BAND_COLORS = {
  high: '#3cc6f3',
  moderate: '#f5a335',
  basic: '#838383',
  low: '#ff00c6'
};

// Level | Description columns, shared by the header row and the level rows. The level
// column fits the longest level name on one line (vi "Trung bình").
const RUBRIC_COLUMNS = '7em minmax(0, 1fr)';

// Gutter left of the rows for the score scale: fits a three-digit mark and its gap
const RUBRIC_SCALE_WIDTH = '2.8em';

export const RubricHeaderRow = styled.div`
  display: grid;
  grid-template-columns: ${RUBRIC_COLUMNS};
  margin-left: ${RUBRIC_SCALE_WIDTH};
  /* Lines the headers up with the cells behind the rows' colour bar */
  border-left: 12px solid transparent;
  margin-bottom: 6px;
`;

export const RubricHeaderCell = styled.div`
  padding: 0 10px;
  font-size: 0.9em;
  font-weight: 700;
  color: #4b5563;

  &:last-child {
    padding-left: 5px;
  }
`;

export const RubricRow = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: ${RUBRIC_COLUMNS};
  align-items: center;
  min-height: 56px;
  margin-left: ${RUBRIC_SCALE_WIDTH};
  margin-bottom: 4px;
  border-left: 12px solid ${({ $band }) => RUBRIC_BAND_COLORS[$band]};

  /* The learner's level: same values as .rubric-row--current (quiz_result.page.css) */
  ${({ $current }) => $current && `
    background-color: #ffffff;
    border-radius: 0 8px 8px 0;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.14);
  `}
`;

// Score scale mark: a row's upper bound on its top edge and, with $floor, the bottom
// of the scale under the last row. Positioned against its own row, in the gutter left
// of the colour bar, so it stays on the row's edge however far the description wraps.
export const RubricScaleTick = styled.span`
  position: absolute;
  /* The row's padding box starts after its 12px colour bar */
  right: calc(100% + 12px + 0.3em);
  top: ${({ $floor }) => ($floor ? '100%' : '0')};
  transform: translateY(-50%);
  font-family: 'Lemon/Milk';
  font-size: 1.3em;
  font-weight: bold;
  line-height: 1;
  white-space: nowrap;
  color: ${({ $floor, $band }) => ($floor ? '#000000' : RUBRIC_BAND_COLORS[$band])};
`;

export const RubricLevelCell = styled.div`
  padding: 8px 10px;
  font-size: 1.05em;
  font-weight: 800;
  line-height: 1.2;
  color: ${({ $band }) => RUBRIC_BAND_COLORS[$band]};
`;

export const RubricDescCell = styled.div`
  padding: 8px 10px 8px 5px;
  line-height: 1.35;
  text-align: left;

  ${({ $current }) => $current && `
    font-weight: 600;
    color: #19174a;
  `}
`;

// Score text styling
export const ScoreInt = styled.span`
  color: ${({ isZero }) => (isZero ? '#ff2C2C' : 'inherit')};
    font-size: 70px;
`;

export const ScoreLabelPt = styled.span`
  font-size: 40px;
  margin-top: -20px;
  vertical-align: top;
  color: ${({ isZero }) => (isZero ? '#ff2C2C' : 'inherit')};
`;

// TemplateHtmlContent Styles
export const HtmlContentLayout = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
  align-items: stretch;
  
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

export const HtmlImageContainer = styled.div`
  flex: 0 0 40%;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  &::before {
    content: "";
    display: block;
    flex: 1;
  }
  
  &::after {
    content: "";
    display: block;
    flex: 4;
  }
  
  @media (max-width: 960px) {
    flex: 1;
    width: 100%;
    
    &::before,
    &::after {
      display: none;
    }
  }
`;

export const ImagePlaceholder = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HtmlContentColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const HtmlContentWrapper = styled.div`
  width: 100%;
  line-height: 1.6;
  font-size: 18px;
  color: #000;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  
  & * {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-user-drag: none;
    pointer-events: auto;
  }
`;

// Case study (TemplateGraphicAndText, slide_type case_study). Part 1 stacks the
// section cards beside the image; part 2 has no image and lays them out in a grid.
export const CaseStudySections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${({ $fullWidth }) => $fullWidth && `
    @media (min-width: 1024px) {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    }
  `}
`;

export const CaseStudySection = styled.section`
  background: #FFF7F2;
  border-radius: 8px;
  padding: 14px 16px;
  ${({ $fullRow }) => $fullRow && 'grid-column: 1 / -1;'}
`;

export const CaseStudySectionLabel = styled.h3`
  margin: 0 0 6px;
  color: #EE6D29;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

export const CaseStudySectionBody = styled.div`
  color: #000;
  font-size: 18px;
  line-height: 1.5;

  p {
    margin: 0;
  }

  p + p,
  p + ul {
    margin-top: 6px;
  }

  @media (max-width: 1024px) {
    font-size: 16px;
  }
`;

export const CaseStudyBulletList = styled.ul`
  margin: 0;
  padding-left: 22px;
  list-style-type: disc;

  li + li {
    margin-top: 4px;
  }
`;

export const CaseStudyNumberedList = styled.ol`
  margin: 0;
  padding-left: 22px;
  list-style-type: decimal;

  li + li {
    margin-top: 4px;
  }
`;

export const CaseStudyChoiceList = styled.ul`
  margin: 0;
  padding-left: 0;
  list-style-type: none;

  li + li {
    margin-top: 4px;
  }
`;

export const CaseStudyChoiceLetter = styled.span`
  margin-right: 6px;
  color: #EE6D29;
  font-weight: 700;
`;

// Legacy case_snippet: one block per paragraph, in the slide body font
export const CaseStudyParagraph = styled(PointText)`
  & + & {
    margin-top: 16px;
  }
`;

// These classes (scenario-text, speech-bubble, reveal-big, outcome-*, content-*,
// taxonomy/spectrum/narrative frameworks, etc.) are shared markup produced by
// several different slide layouts (HtmlContentSlide, GraphicAndTextSlide,
// CaseStudyCard, WhyOutcomeCards, KeyPointsList), which don't all render inside
// HtmlContentWrapper - so this has to be a real global style, not nested CSS
// scoped to one styled-component, or it silently doesn't apply outside
// HtmlContentSlide. Mounted once via <SlideContentGlobalStyles /> in CourseTime.page.jsx.
export const SlideContentGlobalStyles = createGlobalStyle`
  /* Storytelling templates styles */
  .scenario-text {
    font-size: 1.1rem;
    color: #1f2937;
    margin-bottom: 16px;
    line-height: 1.6;
  }
  
  .speech-bubble {
    position: relative;
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 16px;
    margin-top: 12px;
    margin-bottom: 16px;
    font-size: 1.05rem;
    font-style: italic;
    color: #111827;
    line-height: 1.5;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    
    &::before {
      content: '💬';
      position: absolute;
      left: -12px;
      top: 14px;
      font-size: 1.25rem;
      background: white;
      border-radius: 50%;
      padding: 2px;
    }
  }

  .reveal-big {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 16px;
    text-align: center;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

    .answer-label {
      font-size: 0.85rem;
      font-weight: 700;
      color: #64748b;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      margin-bottom: 6px;
    }
    
    .answer {
      font-size: 1.4rem;
      font-weight: 800;
      color: #0f172a;
      margin-bottom: 8px;
    }

    .reason {
      font-size: 0.95rem;
      color: #475569;
      line-height: 1.5;
    }
  }

  .action-line {
    background: #f0fdfa;
    border-left: 4px solid #14b8a6;
    border-radius: 0 8px 8px 0;
    padding: 12px 16px;
    font-size: 1rem;
    color: #0d9488;
    line-height: 1.5;
    margin-bottom: 16px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;

    &::before {
      content: '✨';
    }
  }

  /* Outcomes Layout (Why slides / positive & negative outcomes) */
  .outcome-container {
    width: 100%;
    margin-top: 12px;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .outcome-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
    width: 100%;
    align-items: stretch;

    @media (max-width: 600px) {
      grid-template-columns: 1fr;
    }
  }

  .outcome-card {
    border-radius: 10px;
    padding: 14px 16px;
    border: 1px solid;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1;
    width: 100%;
    box-sizing: border-box;

    &.positive {
      background: #f0fdf4;
      border-color: #dcfce7;
    }

    &.negative {
      background: #fffbeb;
      border-color: #fef3c7;
    }
  }

  .outcome-card-image-wrap {
    width: 100%;
    margin-bottom: 12px;
    display: flex;
    justify-content: center;
  }

  .outcome-card-image {
    width: 100%;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    display: block;
    user-select: none;
    -webkit-user-drag: none;
  }

  .outcome-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
  }

  .outcome-icon {
    font-size: 0.95rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .outcome-title {
    font-weight: 800;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;

    &.positive {
      color: #14532d;
    }

    &.negative {
      color: #92400e;
    }
  }

  .outcome-body {
    font-size: 0.9rem;
    line-height: 1.45;
    margin: 0;
    text-align: left;

    &.positive {
      color: #14532d;
    }

    &.negative {
      color: #78350f;
    }
  }

  /* Content points and frameworks styling */
  .content-hook {
    font-size: 1.15rem;
    font-weight: 500;
    color: #1f2937;
    margin-bottom: 18px;
    line-height: 1.6;
  }

  .content-body {
    font-size: 1rem;
    color: #374151;
    margin-bottom: 18px;
    
    p {
      margin-bottom: 12px;
    }
  }

  .recap-list {
    margin-bottom: 18px;
    padding-left: 20px;
    
    li {
      margin-bottom: 8px;
      line-height: 1.5;
      
      strong {
        color: #1e3a8a;
      }
    }
  }

  .info-box {
    margin-top: 16px;
    margin-bottom: 18px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 14px 18px;
    
    .label {
      display: inline-block;
      font-size: 0.75rem;
      font-weight: 800;
      color: #475569;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      margin-bottom: 4px;
    }
    
    p {
      font-size: 1rem;
      font-style: italic;
      color: #334155;
      margin: 0;
      line-height: 1.5;
    }
  }

  .content-so-what {
    font-size: 0.95rem;
    font-weight: 700;
    color: #065f46;
    background: #ecfdf5;
    border-radius: 10px;
    padding: 12px 16px;
    margin-top: 18px;
    margin-bottom: 12px;
    line-height: 1.55;
    text-align: left;
    border-left: 3px solid #10b981;
    
    &::before {
      content: "";
    }
  }

  /* Learning Objective (slo_title) styles */
  .slo-title-card {
    text-align: center;
    padding: 32px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    
    .slo-title-kicker {
      font-size: 1.05rem;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      color: #6366f1;
      font-weight: 700;
      margin-bottom: 16px;
    }
    
    .slo-title-main {
      font-size: 1.85rem;
      font-weight: 800;
      color: #0f172a;
      margin: 0 0 16px;
      line-height: 1.35;
      text-align: center;
      letter-spacing: -0.02em;
    }
    
    .slo-title-icon {
      font-size: 2.75rem;
      margin-bottom: 12px;
    }
  }

  /* Key Learning Points styles */
  .intro-line {
    font-size: 1rem;
    color: #475569;
    margin-bottom: 12px;
    line-height: 1.5;
  }
  
  .key-points {
    list-style: none;
    padding: 0;
    margin: 16px 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
    
    li {
      font-size: 1rem;
      padding: 14px 18px;
      background: #f1f5f9;
      border-radius: 12px;
      display: grid;
      grid-template-columns: 28px 1fr;
      gap: 14px;
      align-items: center;
      
      .icon {
        font-size: 1.4rem;
        line-height: 1;
      }
      
      .key-point-copy {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }
      
      .key-point-phrase strong {
        color: #0f172a;
        font-weight: 700;
      }
      
      .key-point-desc {
        font-size: 0.875rem;
        color: #475569;
        line-height: 1.45;
      }
    }
  }
  
  .key-points-closing {
    margin-top: 16px;
    padding: 12px 16px;
    border-radius: 12px;
    background: #fff7ed;
    color: #9a3412;
    font-size: 0.95rem;
    line-height: 1.5;
    border: 1px solid #fed7aa;
  }

  /* Celebration & Badge Slide Styles (same as the PW preview) */
  .celebration-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
    padding: 10px 20px;
    margin-top: 10px;

    .celebration-badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      padding: 12px 36px;
      border-radius: 9999px;
      background: linear-gradient(135deg, #f59e0b, #d97706);
      color: #ffffff;
      font-weight: 700;
      font-size: 1.2rem;
      margin-bottom: 24px;
      box-shadow: 0 4px 14px rgba(245, 158, 11, 0.3);
      letter-spacing: 0.02em;
    }

    .celebration-message {
      font-size: 1.85rem;
      font-weight: 800;
      color: #0f172a;
      line-height: 1.35;
      margin: 0 0 28px 0;
      max-width: 850px;
      text-align: center;
    }

    .celebration-recaps {
      list-style: disc;
      padding-left: 24px;
      margin: 0;
      text-align: left;
      display: inline-block;
      max-width: 750px;

      li {
        font-size: 1.15rem;
        color: #1e293b;
        line-height: 1.6;
        margin-bottom: 12px;
      }
    }
  }

  /* Illustrative example badge style */
  .illustrative-badge {
    display: inline-block;
    margin-bottom: 14px;
    padding: 4px 12px;
    border-radius: 999px;
    background: #fef3c7;
    color: #92400e;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    border: 1px solid #fde68a;
    line-height: 1.2;
    
    &::before {
      content: "🟡 ";
    }
  }

  /* ContentNew: taxonomy, spectrum, sequence, watchouts, negspace */
  .taxonomy-wrapper {
    margin-top: 12px;
    margin-bottom: 20px;
  }

  .taxonomy-item {
    margin-bottom: 12px;
    line-height: 1.5;
    font-size: 1rem;
    
    .taxonomy-number {
      font-weight: 800;
      color: #1e3a8a;
    }
    
    .taxonomy-title {
      font-weight: 800;
      color: #1e3a8a;
      font-size: 1.05rem;
    }
    
    .taxonomy-sep {
      color: #9ca3af;
    }
    
    .taxonomy-explanation {
      color: #374151;
    }
  }

  .spectrum-container {
    margin-top: 12px;
    margin-bottom: 18px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }

  .spectrum-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    border-bottom: 1px solid #e2e8f0;

    @media (max-width: 640px) {
      grid-template-columns: 1fr;
      
      .spectrum-card.wrong {
        border-right: none;
        border-bottom: 1px solid #e2e8f0;
      }
    }
  }

  .spectrum-card {
    padding: 12px 16px;
    text-align: center;
    
    &.wrong {
      background: #fff5f5;
      border-right: 1px solid #e2e8f0;
    }
    
    &.right {
      background: #f0fdf4;
    }
  }

  .spectrum-label {
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 4px;
    
    &.wrong {
      color: #b91c1c;
    }
    
    &.right {
      color: #15803d;
    }
  }

  .spectrum-value {
    font-size: 1.05rem;
    font-weight: 700;
    
    &.wrong {
      color: #991b1b;
    }
    
    &.right {
      color: #166534;
    }
  }

  .spectrum-details {
    padding: 12px;
    background: #ffffff;
    font-size: 0.9rem;
    color: #475569;
    line-height: 1.5;
    text-align: center;
    font-style: italic;
  }

  .sequence-container {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 12px;
    margin-bottom: 18px;
  }

  .sequence-card {
    padding: 14px;
    border-radius: 8px;
    flex: 1;
    min-width: 240px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    
    &.before {
      background: #f8fafc;
      border-color: #e2e8f0;
    }
    
    &.after {
      background: #f0fdf4;
      border-color: #dcfce7;
    }
  }

  .sequence-title {
    font-weight: 800;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 10px;
    padding-bottom: 6px;
    border-bottom: 2px solid;
    
    &.before {
      color: #475569;
      border-bottom-color: #cbd5e1;
    }
    
    &.after {
      color: #166534;
      border-bottom-color: #bbf7d0;
    }
  }

  .sequence-step {
    margin-bottom: 8px;
    font-size: 0.9rem;
    line-height: 1.45;
    
    .sequence-arrow {
      color: #94a3b8;
    }
    
    .sequence-action {
      font-weight: 700;
      color: #334155;
    }
    
    .sequence-explanation {
      color: #4b5563;
    }
    
    .sequence-card.after & {
      .sequence-arrow {
        color: #22c55e;
      }
      .sequence-action {
        color: #14532d;
      }
    }
  }

  .watch-outs-container {
    margin-top: 18px;
    margin-bottom: 12px;
    padding: 12px 16px;
    background: #fff5f5;
    border-left: 4px solid #ef4444;
    border-radius: 4px;
  }

  .watch-outs-title {
    font-weight: 800;
    color: #991b1b;
    font-size: 0.85rem;
    margin-bottom: 6px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .watch-out-item {
    font-size: 0.9rem;
    color: #7f1d1d;
    line-height: 1.45;
    margin-bottom: 4px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }

  .negative-space-container {
    margin-top: 18px;
    margin-bottom: 12px;
    padding: 12px 16px;
    background: #f8fafc;
    border-left: 4px solid #64748b;
    border-radius: 4px;
    font-size: 0.9rem;
    color: #475569;
    line-height: 1.45;
  }

  /* ContentMore: narrative layouts gap, buffer, collapse */
  .narrative-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 14px;
    margin-top: 12px;
    margin-bottom: 16px;
  }

  .narrative-card {
    border-radius: 8px;
    padding: 14px;
    border: 1px solid;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    
    &.old-workflow {
      background: #fff5f5;
      border-color: #fee2e2;
    }
    
    &.new-workflow {
      background: #f0fdf4;
      border-color: #dcfce7;
    }
    
    &.tempting-shortcut {
      background: #fffbeb;
      border-color: #fef3c7;
    }
    
    &.safety-buffer {
      background: #f0fdf4;
      border-color: #dcfce7;
    }
  }

  .narrative-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
  }

  .narrative-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    font-weight: 900;
    font-size: 0.75rem;
    
    &.old-workflow {
      background: #fee2e2;
      color: #ef4444;
    }
    
    &.new-workflow {
      background: #dcfce7;
      color: #22c55e;
    }
    
    &.tempting-shortcut {
      font-size: 0.95rem;
      background: transparent;
    }
    
    &.safety-buffer {
      font-size: 0.95rem;
      background: transparent;
    }
  }

  .narrative-title {
    font-weight: 800;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    
    &.old-workflow { color: #991b1b; }
    &.new-workflow { color: #14532d; }
    &.tempting-shortcut { color: #92400e; }
    &.safety-buffer { color: #14532d; }
  }

  .narrative-text {
    font-size: 0.9rem;
    margin: 0;
    line-height: 1.45;
    
    &.old-workflow { color: #7f1d1d; }
    &.new-workflow { color: #14532d; }
    &.tempting-shortcut { color: #78350f; }
    &.safety-buffer { color: #14532d; }
  }

  .narrative-collapse-container {
    margin-top: 12px;
    margin-bottom: 16px;
    border: 1px solid #fecaca;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }

  .narrative-collapse-header {
    background: #fffbeb;
    padding: 12px;
    border-bottom: 1px solid #fecaca;
    display: flex;
    align-items: flex-start;
    gap: 10px;
  }

  .narrative-collapse-body {
    background: #fff5f5;
    padding: 14px;
    display: flex;
    align-items: flex-start;
    gap: 12px;
  }

  .narrative-collapse-icon {
    font-size: 1.15rem;
    line-height: 1;
    
    &.crash {
      font-size: 1.5rem;
    }
  }

  .narrative-collapse-header-text,
  .narrative-collapse-body-text {
    flex: 1;
  }

  .narrative-collapse-title {
    font-weight: 800;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 3px;
    
    &.warning { color: #92400e; }
    &.crash { color: #991b1b; }
  }

  .narrative-collapse-desc {
    font-size: 0.9rem;
    color: #78350f;
    line-height: 1.45;
    
    &.crash {
      font-size: 0.95rem;
      color: #7f1d1d;
      font-weight: 600;
    }
  }

  .downstream-outcome {
    margin-top: 14px;
    margin-bottom: 14px;
    font-size: 0.95rem;
    color: #374151;
    line-height: 1.5;
  }

  .final-warning-container {
    margin-top: 14px;
    margin-bottom: 14px;
    padding: 12px;
    background: #fffbeb;
    border-left: 4px solid #d97706;
    border-radius: 4px;
    font-size: 0.95rem;
    color: #78350f;
    line-height: 1.45;
  }
`;

